import React, { useState, useEffect } from 'react'
import SearchResultCard from './SearchResultCard'
import { useDispatch } from 'react-redux'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { searchPostAttachments } from '../../../../actions/project_actions'
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';

const Images = () => {

    const dispatch = useDispatch()
    const history = useNavigate()
    const params = useParams()
    let { search } = useLocation();
    const query = new URLSearchParams(window.decodeURIComponent(search));
    const [attachment, setAttachments] = useState([])
    const [isLoading, setLoading] = useState(true)

    const [page, setPage] = useState(1)
    const [totalPages, setTotalPage] = useState(0)


    const getAttachments = (isNew = true, page = 1) => {
        dispatch(searchPostAttachments({ searchStr: query.get('searchStr'), projectId: params.projectid, page: page, limit: 10 }))
            .then((response) => {
                isNew ? setAttachments([...response.payload.content.posts]) : setAttachments([...attachment, ...response.payload.content.posts])
                setTotalPage(response.payload.content.totalPages)
                setPage(response.payload.content.currentPage)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
            })

    }

    useEffect(() => {
        getAttachments()
    }, [query.get('searchStr')])

    const next = (e) => {
        e.preventDefault()
        getAttachments(false, page + 1)
    }

    return (
        <LoadingOverlay tag="div" active={isLoading}
            styles={{
                overlay: (base) => ({
                    ...base,
                    background: "#fff",
                    opacity: 0.5,
                }),
            }}
            spinner={
                <Loader color="#6c757d" active type="ball-pulse" />
            }>
            <SearchResultCard data={attachment} next={(e) => next(e)} totalPages={totalPages} currentPage={page}/>

        </LoadingOverlay>
    )
}

export default Images
